export { default } from './emotion-smile'
